import http from "../utils/http";
// import { toast } from "../utils/toast";
// 현금영수증 매출 리스트
export const getCashReceiptsSalesList = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post("/cash-receipts/sales/list", body)
      .then((res) => {
        resolve(res);
        // toast.success('현금영수증 매출 리스트가 조회되었습니다.')
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 현금영수증 매출 엑셀
export const getCashReceiptsSalesExcel = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post("/cash-receipts/sales/excel", body, {
        responseType: "arraybuffer",
      })
      .then((res) => {
        resolve(res);
        // toast.success('현금영수증 매출 리스트가 조회되었습니다.')
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 현금영수증 매입 리스트
export const getCashReceiptsPurchaseList = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post('/cash-receipts/purchase/list', body)
      .then((res) => {
        resolve(res);
        // toast.success('현금영수증 매입 리스트가 조회되었습니다.')
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 현금영수증 매입 엑셀
export const getCashReceiptsPurchaseExcel = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post('/cash-receipts/purchase/excel', body, {
        responseType: "arraybuffer",
      })
      .then((res) => {
        resolve(res);
        // toast.success('현금영수증 매입 리스트가 조회되었습니다.')
      })
      .catch((err) => {
        reject(err);
      });
  });
};


// 현금영수증 발행
export const createCashReceiptsIssue = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post('/cash-receipts/issue', body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 현금영수증 취소 발행
export const createCashReceiptsCancelIssue = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post('/cash-receipts/cancelIssue', body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 현금계산서에 거래처 매핑
export const modifyCashReceiptsClients = (type, cashReceiptIdx, clientIdx) => {
  return new Promise((resolve, reject) => {
    http
      .put(`/cash-receipts/${type}/${cashReceiptIdx}/clients/${clientIdx}`)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 현금계산서에 거래처 삭제
export const deleteCashReceiptsClients = (type, cashReceiptIdx) => {
  return new Promise((resolve, reject) => {
    http
      .delete(`/cash-receipts/${type}/${cashReceiptIdx}/clients`)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 현금영수증 매입 상세
export const getCashReceiptsPurchase = (idx) => {
  return new Promise((resolve, reject) => {
    http
      .get(`/cash-receipts/purchase/${idx}`)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 현금영수증 매출 상세
export const getCashReceiptsSales = (idx) => {
  return new Promise((resolve, reject) => {
    http
      .get(`/cash-receipts/sales/${idx}`)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 현금영수증 일괄 발행(엑셀)
export const excelUploadCash = (file) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/cash-receipts/excelupload`, file)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
}